<nz-content>
  <div *ngIf="isRussianUser$ | async" nz-row nzJustify="center">
    <nz-alert class="mirror-alert" nzType="info" nzShowIcon [nzMessage]="mirrorAlertMessage"></nz-alert>
    <ng-template #mirrorAlertMessage>
      {{ 'MIRROR_SITE.MESSAGE' | translate }}
      <a [href]="mirrorSiteUrl">{{ 'MIRROR_SITE.LINK' | translate }}</a>.
    </ng-template>
  </div>

  <div nz-row nzJustify="center">
    <nz-row [nzGutter]="[15, 15]" nzJustify="center" class="categories">
      <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6">
        <a routerLink="/auto">
          <nz-card class="main-card">
            <img src="/assets/images/main-categories/auto.png" class="card-img" alt="auto" loading="lazy" />
            <p class="card-header"><span>{{ 'AUTO' | translate }}</span></p>
          </nz-card>
        </a>
      </nz-col>

      <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6">
        <a routerLink="/moto">
          <nz-card class="main-card">
            <img src="/assets/images/main-categories/moto.png" class="card-img" alt="moto" loading="lazy" />
            <p class="card-header"><span>{{ 'MOTO' | translate }}</span></p>
          </nz-card>
        </a>
      </nz-col>

      <!--<nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6">
        <a routerLink="/oneprice">
          <nz-card class="main-card">
            <img src="/assets/images/main-categories/oneprice.png" class="card-img" alt="oneprice" loading="lazy" />
            <p class="card-header"><span>{{ 'ONEPRICE' | translate }}</span></p>
          </nz-card>
        </a>
      </nz-col>-->

      <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6">
        <a routerLink="/manual-lots">
          <nz-card class="main-card">
            <img src="/assets/images/main-categories/spec-equip.png" class="card-img" alt="arai kenki" loading="lazy" />
            <p class="card-header"><span>ARAI KENKI</span></p>
          </nz-card>
        </a>
      </nz-col>

      <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6">
        <a routerLink="/stats-auto">
          <nz-card class="main-card">
            <img src="/assets/images/main-categories/stats.png" class="card-img" alt="statistics" loading="lazy" />
            <p class="card-header"><span>STATISTICS</span></p>
          </nz-card>
        </a>
      </nz-col>

      <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6">
        <a routerLink="/check-production-dates">
          <nz-card class="main-card">
            <img src="/assets/images/main-categories/check-date.png" class="card-img" alt="check dates" loading="lazy" />
            <p class="card-header"><span>{{ 'CHECK_DATE' | translate }}</span></p>
          </nz-card>
        </a>
      </nz-col>
    </nz-row>
  </div>

  <div nz-row nzJustify="center" class="purchase-statistics">
    <app-user-purchase-statistics></app-user-purchase-statistics>
  </div>

  <app-top-manufacturers></app-top-manufacturers>
</nz-content>

<app-main-alerts [alerts]="alerts$ | async"></app-main-alerts>
